import styled from "styled-components";

export const DeliveryDestinationLocationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .location-status-card {
    border: 1px solid #e0e2e6;
    border-radius: 0.5rem;
    padding: 0.875rem 1rem;
    background: #f8f9fa;

    &.confirmed {
      border-color: #22a06b;
      background: #f3fcf7;
    }

    &.pending {
      border-color: #f5a623;
      background: #fffbf0;
    }
  }

  .location-status-label {
    font-size: 0.75rem;
    font-weight: 600;
    color: #6b7280;
    margin: 0 0 0.25rem;
    text-transform: uppercase;
    letter-spacing: 0.02em;
  }

  .location-status-text {
    margin: 0;
    font-size: 0.875rem;
    color: #24272e;
    line-height: 1.4;
  }

  .location-status-hint {
    margin: 0.375rem 0 0;
    font-size: 0.8125rem;
    color: #6b7280;
  }

  .location-actions {
    display: flex;
    justify-content: flex-start;
  }
`;
